import * as React from 'react';
import './MainFrameComponent.css';

interface IMainFrameComponentProps {
    children?: any
}

class MainFrameComponent extends React.PureComponent<IMainFrameComponentProps> {
    public render() {
        return (
            <div className='w_container'>{this.props.children}</div>
        );
    }
}

export default MainFrameComponent;


// WEBPACK FOOTER //
// ./src/components/MainFrameComponent/MainFrameComponent.tsx